





































































































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import BirthdaysBirthdayDetails from "./BirthdaysBirthdayDetails.vue";

import BirthdayBookingJson from "../../shared/BirthdayBookingJson";
import CustomerJson from "../../shared/CustomerJson";

import { BirthdayBookingStatus } from "../../shared/BirthdayBookingStatus";
import { UserPermissionRank } from "../../shared/UserPermissionRank";

export default Vue.extend({
  name: "BirthdaysMyBirthdays",
  components: {
    Loading,
    BirthdaysBirthdayDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    BirthdayBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      showDetails: false,
      UserPermissionRank: UserPermissionRank,
      BirthdayBookingStatus: BirthdayBookingStatus,
      myBirthdays: null as BirthdayBookingJson[] | null,
      selectedBirthdayId: null as number | null,
      selectedBirthday: null as BirthdayBookingJson | null,
      detailsMode: "read",
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.loadData();
      }
    },

    loadData() {
      this.loadBirthdays(this.loginId);
    },

    async reloadSelectedBirthday() {
      this.selectedBirthday = null;
      this.toggleDetails();
      if (this.selectedBirthdayId != null) {
        try {
          this.selectedBirthday = await this.restClient.getBirthdayBooking(this.selectedBirthdayId);
          this.openDetails(this.selectedBirthday, "read");
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadBirthdays(staffId: number | null) {
      this.myBirthdays = null;
      if (this.restClient != null) {
        try {
          let status = [
            BirthdayBookingStatus.requestedPendingConfirmation,
            BirthdayBookingStatus.offerToCustomer,
            BirthdayBookingStatus.booked,
            BirthdayBookingStatus.readyForPayment,
            BirthdayBookingStatus.paymentExported,
          ];

          let afterDateTime = new Date();
          afterDateTime.setHours(0, 0, 0, 0);

          this.myBirthdays = (
            await this.restClient.getBirthdayBookings(status, staffId, afterDateTime)
          ).birthdayBookings;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    /*
    permissionAble: function(item: BirthdayBookingJson) {
      if (
        this.loginPermission > item.permissionRank ||
        this.loginPermission == this.UserPermissionRank.admin ||
        this.loginId == item.ID
      ) {
        return true
      } else {
        return false
      }
    },
*/

    openDetails(item: BirthdayBookingJson | null, mode: string) {
      if (item != null) {
        //this.selectedBirthday = JSON.parse(JSON.stringify(item))
        this.selectedBirthdayId = item.ID;
      } else {
        this.selectedBirthdayId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    bookedBirthdays(): BirthdayBookingJson[] | null | undefined {
      if (this.myBirthdays != null) {
        var states = ["booked", "readyForPayment", "paymentExported"];
        var bookedBirthdays = this.myBirthdays.filter((i) => states.includes(i.state));
        return bookedBirthdays;
      }
    },

    reservedBirthdays(): BirthdayBookingJson[] | null | undefined {
      if (this.myBirthdays != null) {
        var states = ["requestedPendingConfirmation", "offerToCustomer"];
        var reservedBirthdays = this.myBirthdays.filter((i) => states.includes(i.state));
        return reservedBirthdays;
      }
    },
  },
});
